import { render, staticRenderFns } from "./onlineDataWater2.vue?vue&type=template&id=5c863f53&scoped=true&"
import script from "./onlineDataWater2.vue?vue&type=script&lang=js&"
export * from "./onlineDataWater2.vue?vue&type=script&lang=js&"
import style0 from "./onlineDataWater2.vue?vue&type=style&index=0&id=5c863f53&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c863f53",
  null
  
)

export default component.exports